// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type CatalogSchematisation,
  CatalogSchematisationFromJSON,
  CatalogSchematisationToJSON,
} from "../models/CatalogSchematisation";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type MigrateSchematisationsBody,
  MigrateSchematisationsBodyFromJSON,
  MigrateSchematisationsBodyToJSON,
} from "../models/MigrateSchematisationsBody";
import {
  type SchematisationReference,
  SchematisationReferenceFromJSON,
  SchematisationReferenceToJSON,
} from "../models/SchematisationReference";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface JobModelSchematisationsCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  branch?: string;
}

export interface JobThreediSchematisationsAddRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  path: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  branch?: string;
}

export interface MigrationModelSchematisationsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  migrateSchematisationsBody: MigrateSchematisationsBody;
}

export interface ModelSchematisationsCopyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
  /**
   *
   */
  revisionId?: number | null;
}

export interface ModelSchematisationsCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
  /**
   *
   */
  description?: string | null;
}

export interface ModelSchematisationsSubmitRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  branch?: string;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  schematisationId?: number | null;
}

export interface ThreediSchematisationsAddRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
}

export interface ThreediSchematisationsListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: ThreediSchematisationsListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Filter by name (case-insensitive)
   */
  nameIcontains?: string | null;
}

export interface UpdateRevisionIdRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  schematisationId: number;
  /**
   *
   */
  userId: string;
  /**
   *
   */
  branch?: string;
  /**
   *
   */
  xHccSecret?: string | null;
}

/**
 *
 */
export class ThreediSchematisationsApi extends runtime.BaseAPI {
  /**
   * Creates request options for jobModelSchematisationsCreate without sending the request
   */
  async jobModelSchematisationsCreateRequestOpts(
    requestParameters: JobModelSchematisationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobModelSchematisationsCreate().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobModelSchematisationsCreate().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling jobModelSchematisationsCreate().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobModelSchematisationsCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/model-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add a model schematisation to a project from a job
   * Add model schematisation from a job
   */
  async jobModelSchematisationsCreateRaw(
    requestParameters: JobModelSchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationReference>> {
    const requestOptions = await this.jobModelSchematisationsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationReferenceFromJSON(jsonValue)
    );
  }

  /**
   * Add a model schematisation to a project from a job
   * Add model schematisation from a job
   */
  async jobModelSchematisationsCreate(
    requestParameters: JobModelSchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationReference> {
    const response = await this.jobModelSchematisationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobThreediSchematisationsAdd without sending the request
   * @deprecated
   */
  async jobThreediSchematisationsAddRequestOpts(
    requestParameters: JobThreediSchematisationsAddRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobThreediSchematisationsAdd().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobThreediSchematisationsAdd().'
      );
    }

    if (requestParameters["schematisationId"] == null) {
      throw new runtime.RequiredError(
        "schematisationId",
        'Required parameter "schematisationId" was null or undefined when calling jobThreediSchematisationsAdd().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling jobThreediSchematisationsAdd().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobThreediSchematisationsAdd().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation_id"] = requestParameters["schematisationId"];
    }

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/threedi-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add a HCC schematisation to a project from a job
   * Add HCC schematisation from a job
   * @deprecated
   */
  async jobThreediSchematisationsAddRaw(
    requestParameters: JobThreediSchematisationsAddRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationReference>> {
    const requestOptions = await this.jobThreediSchematisationsAddRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationReferenceFromJSON(jsonValue)
    );
  }

  /**
   * Add a HCC schematisation to a project from a job
   * Add HCC schematisation from a job
   * @deprecated
   */
  async jobThreediSchematisationsAdd(
    requestParameters: JobThreediSchematisationsAddRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationReference> {
    const response = await this.jobThreediSchematisationsAddRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for migrationModelSchematisations without sending the request
   */
  async migrationModelSchematisationsRequestOpts(
    requestParameters: MigrationModelSchematisationsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling migrationModelSchematisations().'
      );
    }

    if (requestParameters["migrateSchematisationsBody"] == null) {
      throw new runtime.RequiredError(
        "migrateSchematisationsBody",
        'Required parameter "migrateSchematisationsBody" was null or undefined when calling migrationModelSchematisations().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/migrations/model-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MigrateSchematisationsBodyToJSON(requestParameters["migrateSchematisationsBody"]),
    };
  }

  /**
   * Migrate towards new project-owned schematisations
   */
  async migrationModelSchematisationsRaw(
    requestParameters: MigrationModelSchematisationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.migrationModelSchematisationsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Migrate towards new project-owned schematisations
   */
  async migrationModelSchematisations(
    requestParameters: MigrationModelSchematisationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.migrationModelSchematisationsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for modelSchematisationsCopy without sending the request
   */
  async modelSchematisationsCopyRequestOpts(
    requestParameters: ModelSchematisationsCopyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling modelSchematisationsCopy().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling modelSchematisationsCopy().'
      );
    }

    if (requestParameters["schematisationId"] == null) {
      throw new runtime.RequiredError(
        "schematisationId",
        'Required parameter "schematisationId" was null or undefined when calling modelSchematisationsCopy().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling modelSchematisationsCopy().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation_id"] = requestParameters["schematisationId"];
    }

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    if (requestParameters["revisionId"] != null) {
      queryParameters["revision_id"] = requestParameters["revisionId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/model-schematisations/copy`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Copy a model schematisation into the project
   * Copy model
   */
  async modelSchematisationsCopyRaw(
    requestParameters: ModelSchematisationsCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationReference>> {
    const requestOptions = await this.modelSchematisationsCopyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationReferenceFromJSON(jsonValue)
    );
  }

  /**
   * Copy a model schematisation into the project
   * Copy model
   */
  async modelSchematisationsCopy(
    requestParameters: ModelSchematisationsCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationReference> {
    const response = await this.modelSchematisationsCopyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for modelSchematisationsCreate without sending the request
   */
  async modelSchematisationsCreateRequestOpts(
    requestParameters: ModelSchematisationsCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling modelSchematisationsCreate().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling modelSchematisationsCreate().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling modelSchematisationsCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    if (requestParameters["description"] != null) {
      queryParameters["description"] = requestParameters["description"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/model-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add a model schematisation to a project
   * Add model schematisation
   */
  async modelSchematisationsCreateRaw(
    requestParameters: ModelSchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationReference>> {
    const requestOptions = await this.modelSchematisationsCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationReferenceFromJSON(jsonValue)
    );
  }

  /**
   * Add a model schematisation to a project
   * Add model schematisation
   */
  async modelSchematisationsCreate(
    requestParameters: ModelSchematisationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationReference> {
    const response = await this.modelSchematisationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for modelSchematisationsSubmit without sending the request
   */
  async modelSchematisationsSubmitRequestOpts(
    requestParameters: ModelSchematisationsSubmitRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling modelSchematisationsSubmit().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling modelSchematisationsSubmit().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling modelSchematisationsSubmit().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["name"] != null) {
      queryParameters["name"] = requestParameters["name"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    if (requestParameters["description"] != null) {
      queryParameters["description"] = requestParameters["description"];
    }

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation_id"] = requestParameters["schematisationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/model-schematisations/submit`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Submit a model schematisation from the project to the catalog
   * Submit a model schematisation to the catalog
   */
  async modelSchematisationsSubmitRaw(
    requestParameters: ModelSchematisationsSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CatalogSchematisation>> {
    const requestOptions = await this.modelSchematisationsSubmitRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CatalogSchematisationFromJSON(jsonValue)
    );
  }

  /**
   * Submit a model schematisation from the project to the catalog
   * Submit a model schematisation to the catalog
   */
  async modelSchematisationsSubmit(
    requestParameters: ModelSchematisationsSubmitRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CatalogSchematisation> {
    const response = await this.modelSchematisationsSubmitRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threediSchematisationsAdd without sending the request
   * @deprecated
   */
  async threediSchematisationsAddRequestOpts(
    requestParameters: ThreediSchematisationsAddRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling threediSchematisationsAdd().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling threediSchematisationsAdd().'
      );
    }

    if (requestParameters["schematisationId"] == null) {
      throw new runtime.RequiredError(
        "schematisationId",
        'Required parameter "schematisationId" was null or undefined when calling threediSchematisationsAdd().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling threediSchematisationsAdd().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["schematisationId"] != null) {
      queryParameters["schematisation_id"] = requestParameters["schematisationId"];
    }

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/threedi-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add a HCC schematisation to a project
   * Add HCC schematisation
   * @deprecated
   */
  async threediSchematisationsAddRaw(
    requestParameters: ThreediSchematisationsAddRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SchematisationReference>> {
    const requestOptions = await this.threediSchematisationsAddRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SchematisationReferenceFromJSON(jsonValue)
    );
  }

  /**
   * Add a HCC schematisation to a project
   * Add HCC schematisation
   * @deprecated
   */
  async threediSchematisationsAdd(
    requestParameters: ThreediSchematisationsAddRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SchematisationReference> {
    const response = await this.threediSchematisationsAddRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for threediSchematisationsList without sending the request
   */
  async threediSchematisationsListRequestOpts(
    requestParameters: ThreediSchematisationsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling threediSchematisationsList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["nameIcontains"] != null) {
      queryParameters["name__icontains"] = requestParameters["nameIcontains"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/threedi-schematisations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * List direct HCC schematisations present in tenant
   * List HCC schematisations in tenant
   */
  async threediSchematisationsListRaw(
    requestParameters: ThreediSchematisationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: any | null }>> {
    const requestOptions = await this.threediSchematisationsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * List direct HCC schematisations present in tenant
   * List HCC schematisations in tenant
   */
  async threediSchematisationsList(
    requestParameters: ThreediSchematisationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: any | null }> {
    const response = await this.threediSchematisationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for updateRevisionId without sending the request
   */
  async updateRevisionIdRequestOpts(
    requestParameters: UpdateRevisionIdRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling updateRevisionId().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling updateRevisionId().'
      );
    }

    if (requestParameters["schematisationId"] == null) {
      throw new runtime.RequiredError(
        "schematisationId",
        'Required parameter "schematisationId" was null or undefined when calling updateRevisionId().'
      );
    }

    if (requestParameters["userId"] == null) {
      throw new runtime.RequiredError(
        "userId",
        'Required parameter "userId" was null or undefined when calling updateRevisionId().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["userId"] != null) {
      queryParameters["user_id"] = requestParameters["userId"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xHccSecret"] != null) {
      headerParameters["x-hcc-secret"] = String(requestParameters["xHccSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/threedi-schematisations/{schematisation_id}/update-revision`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );
    urlPath = urlPath.replace(
      "{schematisation_id}",
      encodeURIComponent(String(requestParameters["schematisationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Update a HCC schematisation to point to the latest revision
   * Update HCC schematisation revision
   */
  async updateRevisionIdRaw(
    requestParameters: UpdateRevisionIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.updateRevisionIdRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Update a HCC schematisation to point to the latest revision
   * Update HCC schematisation revision
   */
  async updateRevisionId(
    requestParameters: UpdateRevisionIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.updateRevisionIdRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ThreediSchematisationsListOrderByEnum = {
  Created: "created",
  Created2: "-created",
  LastUpdated: "last_updated",
  LastUpdated2: "-last_updated",
  Name: "name",
  Name2: "-name",
  CreatedByUsername: "created_by__username",
  CreatedByUsername2: "-created_by__username",
} as const;
export type ThreediSchematisationsListOrderByEnum =
  (typeof ThreediSchematisationsListOrderByEnum)[keyof typeof ThreediSchematisationsListOrderByEnum];
